export enum EditableStateEnum {
    None = "None",
    View = "View",
    Edit = "Edit"
}